import { ScrollText, Landmark, Coins, Feather, IdCard, Users, ShieldCheck, Network, Vote, Archive, Gem, Fingerprint, Globe, Banknote } from "lucide-react";

// Interactive tribal governance structure (decentralized sovereign bureau)
export const TRIBAL_STRUCTURE = {
  id: "council",
  title: "The Council of Seven Generations",
  role: "Sovereign Governing Body",
  icon: "council",
  summary:
    "The apex governing council of the Trust. Every ruling is weighed against its impact seven generations forward. The Council holds the seals of the registry and ratifies the institution's stewardship of lineage and assets.",
  children: [
    {
      id: "steward",
      title: "Office of the Steward",
      role: "Executive Stewardship",
      summary: "Executes Council directives, safeguards the institutional charter, and represents the Trust to aligned networks and general partners.",
    },
    {
      id: "registry",
      title: "The Modern Freedmen Bureau",
      role: "Registry & Records",
      summary: "The independent, decentralized ancestry registry. Timestamps, encrypts, and permanently anchors genealogies and issues digital economic citizenship credentials.",
    },
    {
      id: "treasury",
      title: "Treasury & Stewardship Office",
      role: "Assets & Prosperity",
      summary: "Manages shared assets and prosperity instruments across generations with the discipline of a sovereign wealth fund and the intimacy of a family office.",
    },
    {
      id: "culture",
      title: "Cultural Preservation Office",
      role: "Heritage & Memory",
      summary: "Curates oral histories, cultural memory, and the ancestral archive of Woodland Mississippian and Modern Freedmen heritage.",
    },
    {
      id: "membership",
      title: "Membership & Citizenship Office",
      role: "Constituents & Chapters",
      summary: "Verifies eligibility, issues membership IDs, and coordinates the mutual-aid networks and regional chapters.",
      children: [
        { id: "ch-woodland", title: "Woodland Mississippian Chapter", role: "Regional Chapter", summary: "Mutual-aid network anchoring Woodland Mississippian descendants." },
        { id: "ch-freedmen", title: "Modern Freedmen Chapter", role: "Regional Chapter", summary: "Dedicated pathway and network for Modern Freedmen lineages." },
        { id: "ch-urban", title: "Urban Diaspora Chapter", role: "Regional Chapter", summary: "Connects unaffiliated Urban Indian descendants across cities." },
      ],
    },
  ],
};

export const BENEFITS = [
  { icon: Fingerprint, title: "Immutable Ancestry Record", text: "Your genealogy timestamped and encrypted on the Decentralized Blockchain Ancestry Registry — permanent and family-controlled.", featured: true },
  { icon: IdCard, title: "Membership ID Credential", text: "An instant digital economic citizenship credential, plus the option of an embossed physical ID card mailed to you.", featured: true },
  { icon: ShieldCheck, title: "Data Sovereignty Guarantee", text: "Your archives remain private, unalterable, and controlled by your lineage — never by external government bodies.", featured: true },
  { icon: Network, title: "Mutual-Aid Network Access", text: "Membership in your regional chapter — a network pooling knowledge, resources, and support." },
  { icon: Landmark, title: "Institutional Recognition", text: "Lineage anchoring and standing through an independent, sovereign-minded institution." },
  { icon: Archive, title: "Cultural Archive Access", text: "Access to the preserved oral histories and cultural memory of the Trust." },
  { icon: Coins, title: "Prosperity Instruments", text: "Participation in economic sovereignty tools and shared stewardship of assets." },
  { icon: Banknote, title: "Multi-Generational Financial Systems", text: "Access to multiple generational financial assets and systems built to compound heritage into lasting prosperity." },
  { icon: Globe, title: "Global Reservation Access", text: "Access to global reservations across boards with affiliate tribal nations." },
];
